import { FormattedMessage } from 'react-intl';

import { Button } from '../common/Button';
import styles from './BackButton.module.scss';

interface BackButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

const BackButton = ({ disabled, onClick }: BackButtonProps) => (
  <Button kind="tertiary" className={styles.wrapper} disabled={disabled} onClick={onClick}>
    <img src="/images/new-order/back-arrow.svg" width="16" height="16" alt="" />
    <FormattedMessage
      id="layout.backButton"
      defaultMessage="Back"
      description="Layout button that switches to the previous step"
    />
  </Button>
);

export default BackButton;
